import moment from "moment";
import { jsPDF } from 'jspdf'

import { NotasExcell, Titulos_todos, Ver_Valores, conexiones } from "../../../../constantes";

export const Nota_Entera = (nota)=>{
    return Math.trunc(Number(nota)+0.5) 
}

export const NotaLiteral = (notas,nota, actual)=>{
    //notas: notas del estudiante
    //nota: el key de la nota que se desea mostar
    //actual: el valor actual que tiene la nota
    const materia = nota && nota!==undefined ? nota.split('-'): [];
    if  (   materia.length>1 
            && (['PARTICIPACIÓN EN GRUPOS DE CREACIÓN, RECREACIÓN Y PRODUCCIÓN',
                'ORIENTACIÓN Y CONVIVENCIA', 'INVESTIGACIÓN'].indexOf(notas[`asignatura_${materia[1]}_nombre`])!==-1
                ||
                (materia[1]==="def" && ['PARTICIPACIÓN EN GRUPOS DE CREACIÓN, RECREACIÓN Y PRODUCCIÓN',
                'ORIENTACIÓN Y CONVIVENCIA', 'INVESTIGACIÓN'].indexOf(notas[`asignatura_${materia[0]}_nombre`])!==-1)
            )
        )
    {
        
        return notas[nota] ? Literal(notas[nota]) : ''
    }else {
        return actual ? actual : nota ? notas[nota]: undefined;
    }
}
export const Literal = (valor)=>{
    const nota =Nota_Entera(valor);
    
    if (nota>=18){
        return 'A'
    }else if (nota>=15){
        return 'B'
    }else if (nota>=12){
        return 'C'
    }else if (nota>=10){
        return 'D'
    }else{
        return 'D'//return 'E'
    }
}
const Promedio = (nota)=>{
    let resultado =0;
    nota.map(val=>{
        resultado+=Nota_Entera(val);
        return val
    })
    resultado = nota.length !==0  ? resultado/nota.length : 0;
    if (isNaN(resultado)){
        return 0
    }
    return resultado
}

export const Notas_Promedio = (asignaturas, notas)=>{
    asignaturas = asignaturas.map(val=> val.valores ? val.valores : val).sort((a,b)=> Number(a.item)>Number(b.item) ? 1 : -1);
    asignaturas= asignaturas.filter(val=> 
            (val.grado.value==='1er' && Number(val.item)<8)
            || (val.grado.value==='2do' && Number(val.item)<8)
            || (val.grado.value==='3er' && Number(val.item)<9)
            || (val.grado.value==='4to' && Number(val.item)<10)
            || (val.grado.value==='5to' && Number(val.item)<11)
            
    )
    let datos=notas.map(val=>{
        //para calcular pormedio

        let pnotas = {lapso1:[],lapso2:[],lapso3:[], definitiva:[]}
        let notasc = {}
        let notas_asignatura ={};
        //let notas_docentes = {};
        
        let nueva = Calculo_notas(val.valores)
        
        //Object.keys(val.valores).map(d=>{
        Object.keys(nueva).map(d=>{
            if ((d.indexOf('1lapso')!==-1 || d.indexOf('2lapso')!==-1 || d.indexOf('3lapso')!==-1)){
                const pos = asignaturas.findIndex(f=> f._id===d.split('-')[1]);
                
                if (pos!==-1 ){//&& asignaturas[pos].asignatura.indexOf('PRÁCTICA')===-1){
                    
                    
                    let nota = Nota_comun(asignaturas,d, nueva)
                    if (asignaturas[pos].asignatura=="INGLÉS Y OTRAS LENGUAS EXTRANJERAS" || asignaturas[pos].asignatura=="INGLÉS PRÁCTICA"){

                        console.log('>>>>>>>>',asignaturas[pos],nota, d)
                    }
                    let campo = Object.keys(nota);
                    nueva={...nueva, ...nota}
                    if (asignaturas[pos].principal===undefined){
                        //nueva={...nueva, ...nota}
                        notasc[`${d.split('-')[0]}-${d.split('-')[1]}`]= nueva[`${d.split('-')[0]}-${d.split('-')[1]}-consejo`] 
                            ?  nueva[`${d.split('-')[0]}-${d.split('-')[1]}-consejo`]
                            :  nueva[`${d.split('-')[0]}-${d.split('-')[1]}-art112`] 
                            ?  nueva[`${d.split('-')[0]}-${d.split('-')[1]}-art112`] 
                            :  nueva[`${d.split('-')[0]}-${d.split('-')[1]}`];
                        notasc[`${d.split('-')[0]}-${d.split('-')[1]}`]=Number(notasc[`${d.split('-')[0]}-${d.split('-')[1]}`]);
                        notasc[`${d.split('-')[1]}`]=asignaturas[pos].asignatura    
                        // notasc[`${d.split('-')[0]}-${d.split('-')[1]}`]= val.valores[`${d.split('-')[0]}-${d.split('-')[1]}-consejo`] 
                        //     ?  val.valores[`${d.split('-')[0]}-${d.split('-')[1]}-consejo`]
                        //     :  val.valores[`${d.split('-')[0]}-${d.split('-')[1]}-art112`] 
                        //     ?  val.valores[`${d.split('-')[0]}-${d.split('-')[1]}-art112`] 
                        //     :  val.valores[`${d.split('-')[0]}-${d.split('-')[1]}`];
                        // notasc[`asignatura_${d.split('-')[1]}_nombre`]=val.valores[`asignatura_${d.split('-')[1]}_nombre`]
                    }
                }
            }else if (d.indexOf('-def')!==-1){
                pnotas.definitiva = [...pnotas.definitiva, Number(nueva[d])];
                //pnotas.definitiva = [...pnotas.definitiva, Number(val.valores[d])];
            }else if(d.indexOf("asignatura_")!==-1 
                && (d.indexOf("_nombre")===-1 && d.indexOf("_id_docente")===-1 &&d.indexOf("_docente")===-1)){
                    
                    notas_asignatura[nueva[d]]={
                      ...notas_asignatura[nueva[d]],
                      [`${d}_nombre`]: nueva[`${d}_nombre`],
                      docentes:{
                        ...notas_asignatura[nueva[d]] && notas_asignatura[nueva[d]].docentes 
                            ? notas_asignatura[nueva[d]]
                            :   {
                                    [`${d}_id_docente`]: {
                                        docente : nueva[`${d}_docente`],
                                        notas : []
                                    }
                                    
                                }
                                
                      }
                    
                    }

                    // notas_asignatura[val.valores[d]]={
                    //   ...notas_asignatura[val.valores[d]],
                    //   [`${d}_nombre`]: val.valores[`${d}_nombre`],
                    //   docentes:{
                    //     ...notas_asignatura[val.valores[d]] && notas_asignatura[val.valores[d]].docentes 
                    //         ? notas_asignatura[val.valores[d]]
                    //         :   {
                    //                 [`${d}_id_docente`]: {
                    //                     docente : val.valores[`${d}_docente`],
                    //                     notas : []
                    //                 }
                                    
                    //             }
                                
                    //   }
                    
                    // }
                    
            }
            return d;
        })
        console.log(notasc);
        Object.keys(notasc).map(d=>{
            
            if (d.indexOf('1lapso')!==-1){
                pnotas.lapso1= [...pnotas.lapso1, Number(notasc[d])];
            }else if (d.indexOf('2lapso')!==-1){
                pnotas.lapso2= [...pnotas.lapso2, Number(notasc[d])];
            }else if (d.indexOf('3lapso')!==-1){
                pnotas.lapso3= [...pnotas.lapso3, Number(notasc[d])];
            }
            return d
        })
        
        const lapso1= Promedio(pnotas.lapso1);
        const lapso2= Promedio(pnotas.lapso2);
        const lapso3= Promedio(pnotas.lapso3);
        const definitiva = Promedio(pnotas.definitiva);
        
        const promediol = definitiva!==0 ? definitiva : lapso1!==0 && lapso2!==0 && lapso3!==0 
            ? (lapso1+lapso2+lapso3)/3
            : lapso1!==0 && lapso2!==0 && lapso3===0 
            ? (lapso1+lapso2)/2
            : lapso1!==0 && lapso2===0 && lapso3===0 
            ? lapso1
            : 0
        return {...nueva, lapso1, lapso2,lapso3, promediol, definitiva}
        //return {...val.valores, lapso1, lapso2,lapso3, promediol, definitiva}
    })
    
    return datos
}

export const Promedios = (notas)=>{
    let promedio_total = 0;
    let promedio_momento1 = 0;
    let promedio_momento2 = 0;
    let promedio_momento3 = 0;
    let grados = {

    }

    
    notas.map(val=>{
        promedio_total+=val.promediol;
        promedio_momento1+= isNaN(val.lapso1) ? 0 : Number(val.lapso1);
        promedio_momento2+= isNaN(val.lapso2) ? 0 : Number(val.lapso2);
        promedio_momento3+= isNaN(val.lapso3) ? 0 : Number(val.lapso3);
        if (grados[`${val.grado} ${val.seccion}`]){
            grados[`${val.grado} ${val.seccion}`]={
                lapso1:grados[`${val.grado} ${val.seccion}`].lapso1 + val.lapso1,
                lapso2:grados[`${val.grado} ${val.seccion}`].lapso2 + val.lapso2,
                lapso3:grados[`${val.grado} ${val.seccion}`].lapso3 + val.lapso3,
                promedio:grados[`${val.grado} ${val.seccion}`].promedio + val.promediol, 
                cantidad: grados[`${val.grado} ${val.seccion}`].cantidad + 1
            }
        }else{
            grados[`${val.grado} ${val.seccion}`]={
                lapso1:val.lapso1,lapso2:val.lapso2,lapso3:val.lapso3,
                promedio:val.promediol, 
                cantidad:1
            }
        }
        return val;
    })
    let gradosD = Object.keys(grados).map(val=>{
        grados[val]={
            lapso1:Number(Number(grados[val].lapso1 / grados[val].cantidad).toFixed(2)),
            lapso2:Number(Number(grados[val].lapso2 / grados[val].cantidad).toFixed(2)),
            lapso3:Number(Number(grados[val].lapso3 / grados[val].cantidad).toFixed(2)),
            promedio:Number(Number(grados[val].promedio / grados[val].cantidad).toFixed(2)),
            cantidad:grados[val].cantidad,
        }
        return {...grados[val], seccion:val}
    }).sort((a,b)=> a.seccion>b.seccion ? 1 :-1)
    
    promedio_total = notas.length!==0 ? (promedio_total/notas.length) : 0;
    promedio_momento1 = notas.length!==0 ? (promedio_momento1/notas.length) : 0;
    promedio_momento2 = notas.length!==0 ? (promedio_momento2/notas.length) : 0;
    promedio_momento3 = notas.length!==0 ? (promedio_momento3/notas.length) : 0;

    return {promedio_total, promedio_momento1, promedio_momento2, promedio_momento3, grados, gradosD}
}

export const Calculo_notas = (valores)=>{
    
    let nota ={
        //asignatura: datos.asignatura,
        // docente: datos.docente
    };
    let notas= {};
    
    Object.keys(valores).map(val=>{
        
        if (val.indexOf('Error-')===-1 && valores[val]!=='' && val!=='id' 
        ){
            nota[val]=valores[val];
            const notad = val.split('-');
            if (val.indexOf('nota-')!==-1 && notad.length===2 && [null, undefined].indexOf(valores[val])===-1  ){
                const lapso = valores[`${val}-lapso`] === '1er Lapso' ? '1lapso' : valores[`${val}-lapso`] === '2do Lapso' ? '2lapso' : '3lapso';
                if (notas[valores[`${val}-asignatura`]]===undefined){
                    notas[valores[`${val}-asignatura`]]={
                        asignatura:valores[`asignatura_${valores[`${val}-asignatura`]}_nombre`],//valores[`${val}-asignatura-nombre`],
                        [`notas-${lapso}`]:[Number(valores[val])],
                        [`notas-${lapso}-nombre`]:[`${val} ${valores[`${val}-nombre`]} ${valores[`${val}-lapso`]}`]
                    }
                }else{
                    notas[valores[`${val}-asignatura`]]={
                        ...notas[valores[`${val}-asignatura`]],
                        [`notas-${lapso}`]:
                            notas[valores[`${val}-asignatura`]][`notas-${lapso}`] 
                                ?   [...notas[valores[`${val}-asignatura`]][`notas-${lapso}`], 
                                        Number(valores[val])
                                    ]
                                :   [Number(valores[val])],
                        [`notas-${lapso}-nombre`]:
                                notas[valores[`${val}-asignatura`]][`notas-${lapso}-nombre`] 
                                    ?   [...notas[valores[`${val}-asignatura`]][`notas-${lapso}-nombre`], 
                                            `${val} ${valores[`${val}-nombre`]} ${valores[`${val}-lapso`]}`
                                        ]
                                    :   [`${val} ${valores[`${val}-nombre`]} ${valores[`${val}-lapso`]}`],
                    }
                }
            }
            
        }
        return val;
    })
    
    Object.keys(nota).map(val=>{
        if (val.indexOf('lapso-')!==-1 && val.indexOf('-art112')===-1 && val.indexOf('-consejo')===-1 && val.indexOf('rasgos')===-1 && val.indexOf('-consejo')===-1){
            const data =  val.split('-');
            const lasnotas = notas[data[1]] ? notas[data[1]][`notas-${data[0]}`] : undefined;
            
            if (lasnotas!==undefined){
                let resul = 0; 
                lasnotas.map(res=>{
                    resul+=res;
                    return res
                })
                nota[val]= nota[val+'-rasgos']
                    ?   ((resul/lasnotas.length) * 0.90) + Number(nota[val+'-rasgos'] ? nota[val+'-rasgos'] : 0)
                    :   (resul/lasnotas.length)
            }else{
                nota[val]=null
            }   
        }
        return val
    })
    
    return nota
}

const Codigo = (valor) =>{
    let resultado = valor.split('-');
    let respuesta
    resultado.map(val=>{
        if (['1lapso', '2lapso', '3lapso', 'def', 'consejo'].indexOf(val)===-1){
            respuesta=val
            
        }
        return val
    })
    return respuesta

}
export const Nota_comun = (asignaturas, cod, dat)=>{
    //asignaturas a buscar, codigo de asignatura dependiente, dat notas
    let resulta={}
    const pos = asignaturas.findIndex(f=>f._id===Codigo(cod))
    if (pos!==-1 && asignaturas[pos].principal){
        // nota 1 es la nota practica
        let nota1 = dat[cod] === 0 ? '' : typeof dat[cod]==='number' ? Nota_Entera(Number(dat[cod])) : dat[cod];
        if (cod.indexOf('-consejo')!==-1 && nota1===''){
            let ncod=cod.replace('-consejo','')
            nota1 = dat[ncod] === 0 ? '' : typeof dat[ncod]==='number' ? Nota_Entera(Number(dat[ncod])) : dat[ncod];
        }
        let princ = cod.replace(Codigo(cod), asignaturas[pos].principal._id)
        let nota2 = dat[princ] === 0 ? '' : typeof dat[princ]==='number' ? Nota_Entera(Number(dat[princ])) : dat[princ];
        if (princ.indexOf('-consejo')!==-1 && nota2===''){
            let ncod=princ.replace('-consejo','')
            nota2 = dat[ncod] === 0 ? '' : typeof dat[ncod]==='number' ? Nota_Entera(Number(dat[ncod])) : dat[ncod];
        }
        
        
        let promedio =[]
        if (nota1!==undefined && nota1!==null && nota1!=='' && nota1!==' '){
            promedio=[...promedio, Number(nota1)]
        } 
        if (nota2!==undefined && nota2!==null){
            promedio=[...promedio, Number(nota2)]
        }
        if (promedio.length!==0){
            let total = 0;
            for (var i=0; i<promedio.length;i++){
                total += promedio[i]
            }
            promedio = total/promedio.length;
            promedio = Nota_Entera(promedio)
        }else{
            promedio = null
        }
        
        resulta[princ]=promedio===0 ? '' : promedio
    }else{
        resulta[cod]=cod==='fecha_nacimiento' ? moment(dat[cod]).format("DD/MM/YYYY") : dat[cod] === 0 ? '' : typeof dat[cod]==='number' ? Nota_Entera(Number(dat[cod])) : dat[cod]
    }

    return resulta
}

export const Asignaturas = async(grado)=>{
    //======================= Para asignaturas 
    let asignaturas = await conexiones.Leer_C(['uecla_Asignatura'],{
        uecla_Asignatura:{'valores.grado.titulo':grado}
    })
    if (asignaturas.Respuesta==='Ok'){
        asignaturas=asignaturas.datos.uecla_Asignatura.map(val=>val.valores)
    }else{
        asignaturas=[]
    }
    //=======================
    return asignaturas
}
export const Formato_Boleta = async(est_datos, est_titulos, datos)=>{
    //======================= Para asignaturas dependiente
    let asignatura = await Asignaturas(datos.grado);
    //=======================
    
    let campos = {
        No:'', apellidos:'apellidos', nombres:'nombres'
    };
    est_titulos.values.map(val=>{
        if (['Cedula','Nombres','Apellidos'].indexOf(val.title)===-1){
            campos={...campos, [val.field]:''}
        }
        return val
    })
    delete campos.cedula;
    campos={...campos,
        cedula:'', 
        fecha_nacimiento:'',
        lugar_nacimiento:'',
    }
    let data =[
        campos
    ]
    
    const agregar = data[0];
    for (var i=0;i<3;i++){
        data=[...data, agregar];
    }
    
    est_datos.map((dat,i)=>{
        let nuevo = {No:i+1}
        Object.keys(campos).map(val=>{
            if (['No','_id_estudiante','seccion','grado', 'undefined'].indexOf(val)===-1){
                
                // nuevo[val]= val==='fecha_nacimiento' ? moment(dat[val]).format("DD/MM/YYYY") :dat[val] === 0 ? '' : typeof dat[val]==='number' ? Nota_Entera(Number(dat[val])) : dat[val]
                
                //nuevo[val]=NotaLiteral(dat, val, nuevo[val]);
                nuevo={...nuevo,...Nota_comun(asignatura,val,dat)}
            }
            
            return val
        })
        data=[...data, nuevo]
        return dat
    })
    
    let asigna=[];
    let trismestre=[];
    let subtitulo=['N°',"APELLIDOS Y NOMBRES","APELLIDOS Y NOMBRES"];
    est_titulos.datos[0].map(val=>{
        if (['Cedula','Nombres','Apellidos','ESTUDIANTES'].indexOf(val.title)===-1 && val.title.indexOf('PRÁCTICA')===-1){
            asigna=[...asigna, val.title,val.title,val.title,val.title,val.title,val.title,val.title];
            trismestre=[...trismestre,"1°","1°","2°","2°","3°","3°",""];
            subtitulo=[...subtitulo,'C. PROBABLE','C. PARCIAL','C. PROBABLE','C. PARCIAL','C. PROBABLE','C. PARCIAL','NOTA DEF.']
        }
        return val
    })
    
    asigna=[...asigna,'','','',''];
    subtitulo=[...subtitulo, 'CEDULA', 'FECHA','LUGAR',datos.grado, datos.seccion];
    
    const ano={
        '1er año':'PRIMER',
        '2do año':'SEGUNDO',
        '3er año':'TERCER',
        '4to año':'CUARTO',
        '5to año':'QUINTO'
    }
    const Titulos = [
        [`ASIGNATURAS`,"ASIGNATURAS", "ASIGNATURAS",...asigna],
        ["TRIMESTRE","TRIMESTRE","TRIMESTRE",...trismestre],
        subtitulo,
        ['No',`${ano[datos.grado]} AÑO SECCION "${datos.seccion}"`,"",""],
        ['No',`${datos.periodo}`,"",""]
        
    ];
    let file = await (await fetch("utilidad/boletas.xlsm")).arrayBuffer();
    
    NotasExcell(data, Titulos, file, "Notas", `Boletas-${datos.grado}-${datos.seccion}-${datos.periodo}.xlsm`, "boleta");
    // return {Titulos, data}
}

const Celda = (doc, texto, x, y, x1, alto, letra, aliniar='center', tipoletra="normal" )=>{
    
    doc.setFontSize(letra)
    doc.setFont("arial", tipoletra);
    doc.rect(x, y, x1, alto); //
    let medio = aliniar==='center' ? x +(x1/2) : x+1//-((texto.length/2)+letra+letra)
    let medioa = typeof texto==='object' ? y +3 : (y+(alto/2))+1//-(letra/4);
    doc.text(texto, medio, medioa, null, null, aliniar);

    return doc
}
const NotaB=(estudiante, momento, materia)=>{
    const pos = (materia.title.indexOf('ORIENTACIÓN')!==-1 || materia.title.indexOf('PARTICIPACIÓN')!==-1 || materia.title.indexOf('INVESTIGACIÓN')!==-1) ? 1 : -1
    
    let nota =  estudiante[`${momento}-${materia.field}-consejo`] 
                && estudiante[`${momento}-${materia.field}-consejo`]!==''
                && estudiante[`${momento}-${materia.field}-consejo`]!==0
                ? Number(estudiante[`${momento}-${materia.field}-consejo`])
                :   estudiante[`${momento}-${materia.field}-art112`] 
                    && estudiante[`${momento}-${materia.field}-art112`]!==''
                    && estudiante[`${momento}-${materia.field}-art112`]!==0
                    ? Number(estudiante[`${momento}-${materia.field}-art112`])
                    : Number(estudiante[`${momento}-${materia.field}`])
    
    nota =  nota
            ?  pos===-1 
            ? Nota_Entera(nota) 
            : Literal(nota) 
            : ''
    
    return nota
}
var getImageFromUrl = function(url) {
	var img = new Image();

	img.onError = function() {
		alert('Cannot load image: "'+url+'"');
	};
	img.onload = function() {
		// callback(img);
        return img
	};
	img.src = url;
}
var createPDF = function(imgData) {

	// This is a modified addImage example which requires jsPDF 1.0+
	// You can check the former one at examples/js/basic.js

	// doc.addImage(imgData, 'JPEG', 10, 10, 50, 50, 'monkey'); // Cache the image using the alias 'monkey'
	// doc.addImage('monkey', 70, 10, 100, 120); // use the cached 'monkey' image, JPEG is optional regardless
	// As you can guess, using the cached image reduces the generated PDF size by 50%!

	// Rotate Image - new feature as of 2014-09-20
	// doc.addImage({
	// 	imageData : imgData,
	// 	angle     : -20,
	// 	x         : 10,
	// 	y         : 78,
	// 	w         : 45,
	// 	h         : 58
	// });

}
const Boleta = (doc, tamcuadroI, margen, margenAlto, altoTexto, tamimagen, letra, datos, estudiante, est_titulos)=>{
    // let imgData = getImageFromUrl("logo.jpg");
    // doc.addImage(imgData, 'JPEG', 10, 10, 50, 50, 'monkey'); // Cache the image using the alias 'monkey'
	// doc.addImage('monkey', 70, 10, 100, 120); // use the cached 'monkey' image, JPEG is optional regardl
    var image = new Image();
    image.src = 'https://chsplus-1je2.onrender.com/api/imagen/logoboleta.png'
    doc.addImage(image, "JPEG", margen+2.5, margenAlto+2.5, tamimagen - 5, tamimagen -5);
    let inicia = tamimagen+margen;
    let siguientew = 0;
    let siguienteA =margenAlto+altoTexto;
    let texto='';
    doc.setLineWidth(0.5);
    doc.setFont("arial");
    doc.setFontSize(letra)

    doc=Celda(doc,'BOLETIN DE CALIFICACIONES' , tamimagen+margen, margenAlto, tamcuadroI, altoTexto, letra)
    siguientew = tamcuadroI*0.55;
    
    doc=Celda(doc,'APELLIDOS Y NOMBRES DEL ESTUDIANTE' , inicia, siguienteA, siguientew, altoTexto, letra)
    // doc.rect(inicia, siguienteA, siguientew, altoTexto); //
    // texto = 'APELLIDOS Y NOMBRES DEL ESTUDIANTE';
    // medio = inicia +(siguientew/2)//-((texto.length/2)+letra+letra)
    // doc.text(texto, medio, (siguienteA+altoTexto)-(letra/3), null, null, "center");

    inicia+=siguientew;
    siguientew = tamcuadroI*0.2;
    doc=Celda(doc, 'COD. PLANTEL', inicia, siguienteA, siguientew, altoTexto, letra)
    // doc.rect(inicia, siguienteA, siguientew, altoTexto); //
    // texto = 'COD. PLANTEL';
    // medio = inicia +(siguientew/2)//2
    // doc.text(texto, medio, (siguienteA+altoTexto)-(letra/3), null, null, "center");

    inicia+=siguientew;
    siguientew = tamcuadroI*0.125;
    doc=Celda(doc, 'CURSO', inicia, siguienteA, siguientew, altoTexto, letra)
    // doc.rect(inicia, siguienteA, siguientew, altoTexto); //
    // texto = 'CURSO';
    // medio = inicia +(siguientew/2)//2
    // doc.text(texto, medio, (siguienteA+altoTexto)-(letra/3), null, null, "center");

    inicia+=siguientew;
    siguientew = tamcuadroI*0.125;
    doc=Celda(doc, 'SECC', inicia, siguienteA, siguientew, altoTexto, letra)
    // doc.rect(inicia, siguienteA, siguientew, altoTexto); //
    // texto = 'SECC';
    // medio = inicia +(siguientew/2)//2
    // doc.text(texto, medio, (siguienteA+altoTexto)-(letra/3), null, null, "center");

    //==================================

    inicia = tamimagen+margen;
    siguienteA +=altoTexto;
    siguientew = tamcuadroI*0.55;
    //==============Nombre y apellido de Estudiante
    doc=Celda(doc, estudiante && estudiante.nombres && estudiante.apellidos ? `${estudiante.apellidos} ${estudiante.nombres} `:'', inicia, siguienteA, siguientew, altoTexto, letra,'center','bold')
    
    //==============Codigo plantel
    inicia+=siguientew;
    siguientew = tamcuadroI*0.2;
    doc=Celda(doc, 'PD00151114', inicia, siguienteA, siguientew, altoTexto, letra,'center','bold')
    
    //==============Curso
    inicia+=siguientew;
    siguientew = tamcuadroI*0.125;
    doc=Celda(doc, datos.grado, inicia, siguienteA, siguientew, altoTexto, letra,'center','bold')
    
    //==============Seccion
    inicia+=siguientew;
    siguientew = tamcuadroI*0.125;
    doc=Celda(doc, datos.seccion, inicia, siguienteA, siguientew, altoTexto, letra,'center','bold')
    
    
    //==================================

    inicia = tamimagen+margen;
    siguienteA +=altoTexto;
    siguientew = tamcuadroI*0.25;
    doc=Celda(doc, 'CÉDULA DE IDENTIDAD', inicia, siguienteA, siguientew, altoTexto, letra)
    
    inicia+=siguientew;
    siguientew = tamcuadroI*0.25;
    doc=Celda(doc, 'FECHA DE NACIMIENTO', inicia, siguienteA, siguientew, altoTexto, letra)
    
    inicia+=siguientew;
    siguientew = tamcuadroI*0.25;
    doc=Celda(doc, 'LUGAR DE NACIMIENTO', inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=siguientew;
    siguientew = tamcuadroI*0.25;
    doc=Celda(doc, 'ENTIDAD FEDERAL', inicia, siguienteA, siguientew, altoTexto, letra)

    //==================================

    inicia = tamimagen+margen;
    siguienteA +=altoTexto;
    siguientew = tamcuadroI*0.25;
    //================Cedula del estudiante
    doc=Celda(doc, estudiante && estudiante.cedula ? estudiante.cedula : '', inicia, siguienteA, siguientew, altoTexto, letra,'center','bold')
    
    inicia+=siguientew;
    siguientew = tamcuadroI*0.25;
    //=================Fecha de nacimiento
    doc=Celda(doc, estudiante && estudiante.fecha_nacimiento ? moment(estudiante.fecha_nacimiento).format('DD/MM/YYYY') : '', inicia, siguienteA, siguientew, altoTexto, letra,'center','bold')
    
    inicia+=siguientew;
    siguientew = tamcuadroI*0.25;
    //=================Lugar de nacimiento
    doc=Celda(doc, estudiante ? estudiante.lugar_nacimiento :'', inicia, siguienteA, siguientew, altoTexto, letra,'center','bold')

    inicia+=siguientew;
    siguientew = tamcuadroI*0.25;
    //=================Estado
    doc=Celda(doc, estudiante && estudiante.estado ? estudiante.estado :'', inicia, siguienteA, siguientew, altoTexto, letra,'center','bold')
    
    //==================================

    inicia = tamimagen+margen;
    siguienteA +=altoTexto;
    siguientew = tamcuadroI*0.40;
    doc=Celda(doc, 'NOMBRE Y DIRECCIÓN DEL PLANTE', inicia, siguienteA, siguientew, altoTexto, letra)
    
    inicia+=siguientew;
    siguientew = tamcuadroI*0.44;
    doc=Celda(doc, 'NOMBRE Y DIRECCIÓN DEL PADRE O REP.', inicia, siguienteA, siguientew, altoTexto, letra)
    
    inicia+=siguientew;
    siguientew = tamcuadroI*0.16;
    doc=Celda(doc, 'AÑO ESCOLAR', inicia, siguienteA, siguientew, altoTexto, letra)

    //==================================

    inicia = tamimagen+margen;
    siguienteA +=altoTexto;
    siguientew = tamcuadroI*0.40;
    texto =doc.splitTextToSize(" CALLE NEGRÓN SILVA, ENTRE AVENIDA INDEPENDENCIA Y CALLE GARCÉS, EDIF. U. E. COLEGIO LIBERTADORES DE AMERICA", siguientew , {})
    doc=Celda(doc, texto, inicia, siguienteA, siguientew, altoTexto+6, letra-1, 'left')
    
    inicia+=siguientew;
    siguientew = tamcuadroI*0.44;
    //================Representante
    doc=Celda(doc, datos.representante ? datos.representante : '', inicia, siguienteA, siguientew, altoTexto+6, letra,'center','bold')
    
    inicia+=siguientew;
    siguientew = tamcuadroI*0.16;
    //===================Periodo Escolar
    doc=Celda(doc, datos.periodo, inicia, siguienteA, siguientew, altoTexto+6, letra,'center','bold')

    //=====================================================
    let completo =tamcuadroI+tamimagen
    inicia = margen;
    siguienteA +=altoTexto+8;
    siguientew = completo*0.35;
    
    doc=Celda(doc, 'Resultados de la Evaluación', inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=siguientew;
    siguientew = completo*0.65;
    doc=Celda(doc, 'HISTORIA DEL ALUMNO DURANTE EL AÑO ESCOLAR', inicia, siguienteA, siguientew, altoTexto, letra)
    //=====================================================
    inicia = margen;
    siguienteA +=altoTexto;
    siguientew = completo*0.35;
    
    doc=Celda(doc, 'Áreas del Saber o', inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=siguientew;
    siguientew = completo*0.14;
    doc=Celda(doc, '1er Lapso', inicia, siguienteA, siguientew, altoTexto, letra)
    
    inicia+=completo*0.15; //siguientew;
    siguientew = completo*0.14;
    doc=Celda(doc, '2do Lapso', inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=completo*0.15;//siguientew;
    siguientew = completo*0.14;
    doc=Celda(doc, '3er Lapso', inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=completo*0.15;//siguientew;
    siguientew = completo*0.06;
    doc=Celda(doc, 'FINAL', inicia, siguienteA, siguientew, 2*altoTexto, letra)

    inicia+=siguientew;
    siguientew = completo*0.075;
    doc=Celda(doc, 'REVISIÓN', inicia, siguienteA, siguientew, 2*altoTexto, letra)
    inicia+=siguientew;
    siguientew = completo*0.065;
    texto =doc.splitTextToSize("TOTAL inasist", siguientew , {})
    doc=Celda(doc, texto, inicia, siguienteA, siguientew, 2* altoTexto, letra)

    //=====================================================
    inicia = margen;
    siguienteA +=altoTexto;
    siguientew = completo*0.35;
    
    doc=Celda(doc, 'Asignaturas', inicia, siguienteA, siguientew, altoTexto, letra)
    //1er
    inicia+=siguientew;
    siguientew = completo*0.075;
    doc=Celda(doc, 'Def.LP', inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=siguientew;
    siguientew = completo*0.065;
    doc=Celda(doc, 'Inasist.', inicia, siguienteA, siguientew, altoTexto, letra)
    //2do
    inicia+=completo*0.075;//siguientew;
    siguientew = completo*0.075;
    doc=Celda(doc, 'Def.LP', inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=completo*0.075;//siguientew;
    siguientew = completo*0.065;
    doc=Celda(doc, 'Inasist.', inicia, siguienteA, siguientew, altoTexto, letra)
    //3er
    inicia+=completo*0.075;//siguientew;
    siguientew = completo*0.075;
    doc=Celda(doc, 'Def.LP', inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=completo*0.075;//siguientew;
    siguientew = completo*0.065;
    doc=Celda(doc, 'Inasist.', inicia, siguienteA, siguientew, altoTexto, letra)

    //=====================================================
    //=====================================================
    //=====================================================
    let asignaturas=est_titulos.datos[0];
    let alto = altoTexto;
    let momento1 = 0;
    let cmomento1 = 0;
    let momento2 = 0;
    let cmomento2 = 0;
    let momento3 = 0;
    let cmomento3 = 0;
    let momentof = 0;
    let cmomentof = 0;
    for (var num=1; num<asignaturas.length;num++){  
        let materia =  asignaturas[num];
        inicia = margen;
        siguienteA +=alto;
        siguientew = completo*0.35;
        texto =doc.splitTextToSize(materia.title, siguientew , {})
        
        alto = texto.length===1 ? altoTexto : altoTexto + (altoTexto/1.5)//texto.length * altoTexto;
        
        doc=Celda(doc, texto, inicia, siguienteA, siguientew, alto, letra,'left','bold')
        //1er
        inicia+=siguientew;
        siguientew = completo*0.075;
        
        let pos = (materia.title.indexOf('ORIENTACIÓN')!==-1 || materia.title.indexOf('PARTICIPACIÓN')!==-1 || materia.title.indexOf('INVESTIGACIÓN')!==-1) ? 1 : -1
        let nota = NotaB(estudiante, '1lapso', materia)
        momento1= pos===-1 ? momento1 + Number(nota) : momento1;
        cmomento1 = pos===-1 && nota!=='' ? cmomento1 + 1 : cmomento1;

        doc=Celda(doc, String(nota) , inicia, siguienteA, siguientew, alto, letra, 'center', 'bold')

        inicia+=siguientew;
        siguientew = completo*0.065;
        doc=Celda(doc, '', inicia, siguienteA, siguientew, alto, letra)
        //2do
        inicia+=completo*0.075;//siguientew;
        siguientew = completo*0.075;
        pos = (materia.title.indexOf('ORIENTACIÓN')!==-1 || materia.title.indexOf('PARTICIPACIÓN') !==-1|| materia.title.indexOf('INVESTIGACIÓN')!==-1) ? 1 : -1
        nota = NotaB(estudiante, '2lapso', materia)
        momento2= pos===-1 ? momento2 + Number(nota) : momento2;
        cmomento2 = pos===-1 && nota!=='' ? cmomento2 + 1 : cmomento2;
        doc=Celda(doc, String(nota), inicia, siguienteA, siguientew, alto, letra, 'center', 'bold')

        inicia+=siguientew;
        siguientew = completo*0.065;
        doc=Celda(doc, '', inicia, siguienteA, siguientew, alto, letra)
        //3er
        inicia+=completo*0.075;//siguientew;
        siguientew = completo*0.075;
        nota = NotaB(estudiante, '3lapso', materia)
        momento3= pos===-1 ? momento3 + Number(nota) : momento3;
        cmomento3 = pos===-1 && nota!=='' ? cmomento3 + 1 : cmomento3;
        doc=Celda(doc, String(nota), inicia, siguienteA, siguientew, alto, letra)

        inicia+=siguientew;
        siguientew = completo*0.065;
        
        doc=Celda(doc, '', inicia, siguienteA, siguientew, alto, letra, 'center', 'bold')

        inicia+=completo*0.075;//siguientew;
        siguientew = completo*0.06;
        pos = (materia.title.indexOf('ORIENTACIÓN')!==-1 || materia.title.indexOf('PARTICIPACIÓN')!==-1|| materia.title.indexOf('INVESTIGACIÓN')!==-1)? 1 : -1
        nota = estudiante[`${materia.field}-def`] //[`1lapso-${materia.field}`] 
            ? pos===-1 
            ? Nota_Entera(estudiante[`${materia.field}-def`]) 
            : Literal(estudiante[`${materia.field}-def`]) 
            : '';
        
        momentof= pos===-1 ? momentof + Number(nota) : momentof;
        cmomentof = pos===-1 && nota!=='' ? cmomentof + 1 : cmomentof;
        doc=Celda(doc, String(nota), inicia, siguienteA, siguientew, alto, letra, 'center', 'bold')

        inicia+=siguientew;
        siguientew = completo*0.075;
        doc=Celda(doc, '', inicia, siguienteA, siguientew, alto, letra)
        inicia+=siguientew;
        siguientew = completo*0.065;
        
        doc=Celda(doc, '', inicia, siguienteA, siguientew, alto, letra)
    }
    
    inicia = margen;
    siguienteA +=2*altoTexto;
    siguientew = completo*0.35;
    
    doc=Celda(doc, 'PROMEDIO', inicia, siguienteA, siguientew, altoTexto, letra, 'center', 'bold')
    //1er
    inicia+=siguientew;
    siguientew = completo*0.075;
    
    doc=Celda(doc, cmomento1===0 ? '' :(momento1/cmomento1).toFixed(2), inicia, siguienteA, siguientew, altoTexto, letra, 'center', 'bold')

    inicia+=siguientew;
    siguientew = completo*0.065;
    doc=Celda(doc, '', inicia, siguienteA, siguientew, altoTexto, letra)
    //2do
    inicia+=completo*0.075;//siguientew;
    siguientew = completo*0.075;
    
    doc=Celda(doc, cmomento2===0 ? '' : (momento2/cmomento2).toFixed(2), inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=completo*0.075;//siguientew;
    siguientew = completo*0.065;
    doc=Celda(doc, '', inicia, siguienteA, siguientew, altoTexto, letra)
    //3er
    inicia+=completo*0.075;//siguientew;
    siguientew = completo*0.075;
    doc=Celda(doc, cmomento3===0 ? '' : (momento3/cmomento3).toFixed(2), inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=completo*0.075;//siguientew;
    siguientew = completo*0.065;
    doc=Celda(doc, '', inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=completo*0.075;//siguientew;
    siguientew = completo*0.06;
    
    doc=Celda(doc, cmomentof===0 ? '' : (momentof/cmomentof).toFixed(2), inicia, siguienteA, siguientew, altoTexto, letra)

    inicia+=siguientew;
    siguientew = completo*0.075;
    doc=Celda(doc, '', inicia, siguienteA, siguientew, altoTexto, letra)
    inicia+=siguientew;
    siguientew = completo*0.065;
    doc=Celda(doc, '', inicia, siguienteA, siguientew, altoTexto, letra)
    //==================================
    //=================================
    inicia = 2* margen;
    siguienteA +=2*altoTexto;
    siguientew = completo*0.25;
    
    doc=Celda(doc, 'SELLO', inicia, siguienteA, siguientew, 6* altoTexto, letra)

    inicia+=completo * 0.342;
    siguientew = completo*0.18;
    
    doc=Celda(doc, "FECHA", inicia, siguienteA, siguientew, altoTexto, letra)
    inicia+=siguientew;
    siguientew = completo*0.22;
    doc=Celda(doc, "FIRMA DEL PROF. GUÍA", inicia, siguienteA, siguientew, altoTexto, letra)
    inicia+=siguientew;
    siguientew = completo*0.22;
    doc=Celda(doc, "FIRMA DEL REPRESENTANTE", inicia, siguienteA, siguientew, altoTexto, letra)
    //================================
    inicia = 2* margen;
    siguienteA +=altoTexto;
    siguientew = completo*0.25;

    inicia+=completo * 0.342;
    siguientew = completo*0.18;
    
    doc=Celda(doc, moment().format('MMM-YYYY'), inicia, siguienteA, siguientew, altoTexto, letra, 'center', 'bold')
    inicia+=siguientew;
    siguientew = completo*0.22;
    doc=Celda(doc, "", inicia, siguienteA, siguientew, 3*altoTexto, letra)
    inicia+=siguientew;
    siguientew = completo*0.22;
    doc=Celda(doc, "", inicia, siguienteA, siguientew, 3*altoTexto, letra)
    //================================
    inicia = 2* margen;
    siguienteA +=altoTexto;
    siguientew = completo*0.25;

    inicia+=completo * 0.342;
    siguientew = completo*0.18;
    
    doc=Celda(doc, "LAPSO DE EVALUACIÓN", inicia, siguienteA, siguientew, altoTexto, letra)
    //================================
    inicia = 2* margen;
    siguienteA +=altoTexto;
    siguientew = completo*0.25;

    inicia+=completo * 0.342;
    siguientew = completo*0.18;
    
    doc=Celda(doc, momento3!==0 ? "TERCERO" : momento2!==0 ? "SEGUNDO" :"PRIMERO", inicia, siguienteA, siguientew, altoTexto, letra, 'center', 'bold')
    return doc
}
export const FormatoBoletapdf = (props)=>{
    const {est_datos, est_titulos, datos} = props;
    
    // let asignatura = await Asignaturas(datos.grado);
    var doc = new jsPDF( );
    const totalPagesExp = '{total_pages_count_string}'
    var y = 5;
    
    const pageSize = doc.internal.pageSize
    const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    const pageAlto = pageSize.height ? pageSize.height : pageSize.getHeight()
    

    const margen = 8;
    const margenAlto = 8;
    const altoTexto = 4;
    const tamcuadroI= (pageWidth *0.80)-margen;
    const tamimagen = (pageWidth *0.20)-margen;
    let letra =8;
    
    doc.setFont("arial");
    doc.setFontSize(letra)
    
    // if (est_datos)
    for (var i=0; i< est_datos.length;i++){
        if (i!==0 && i%2===0){
            doc.addPage();
        }else if (i!==0){
            //Linea media
            doc.line(0, pageAlto/2, pageWidth, pageAlto/2); // horizontal line        
        }
        doc = Boleta(doc,tamcuadroI, margen, i%2===0 ? margenAlto : (pageAlto/2) + margenAlto, altoTexto, tamimagen, letra, datos,est_datos[i], est_titulos)    
    }
    // doc = Boleta(doc,tamcuadroI, margen, margenAlto, altoTexto, tamimagen, letra, datos,est_datos[0], est_titulos)
    
    //Linea media
    // doc.line(0, pageAlto/2, pageWidth, pageAlto/2); // horizontal line

    // doc = Boleta(doc,tamcuadroI, margen, (pageAlto/2) + margenAlto, altoTexto, tamimagen, letra, datos,est_datos[0], est_titulos)
    
    return (
        <embed src={`${doc.output('bloburl')}#view=Fit=1&toolbar=1&navpanes=0&scrollbar=1`} type="application/pdf" width="100%" height={'100%' } />
        
    )
}

export const TitulosNotas = async(titulosn, ntipo)=>{
    const Config = Ver_Valores().config;
    let est_titulos = await Titulos_todos(`Titulos_Notas`, Config);
    est_titulos = est_titulos.map(val=>{
        return {...val, }
    })
    let fila1 = titulosn.datos[0].map(asig=>{
        return {
            default : "",
            field : `${asig.field}`,
            formato : (dato)=> dato[asig.field] ? Number(dato[asig.field]).toFixed(2) : '',
            orden: false, 
            tipo : "",
            title : asig.titulo,
            type : "number",
            lapso:asig.lapso,
            vertical:false,
            colSpan:7,                  

        }
    })
                    
    const fila2 = titulosn.datos[1].map(asig=>{
        const definitiva = (asig.field.indexOf("-def")!==-1 || asig.field.indexOf("1lapso-")!==-1 || asig.field.indexOf("2lapso-")!==-1 || asig.field.indexOf("3lapso-")!==-1)
                            && (asig.field.indexOf("-art112")===-1 && asig.field.indexOf("-rasgos")===-1) 
        const tipo =ntipo.value;
        
        return {
            default : "",
            field : `${asig.field}`,
            formato : (dato)=> dato[asig.field] 
                ?   definitiva 
                        ?   Nota_Entera(Number(tipo==='seccion' && dato[`${asig.field}-art112`] 
                                                ?   dato[`${asig.field}-art112`]
                                                :   dato[asig.field]
                                            ))
                        :   Number(dato[asig.field]).toFixed(2) 
                :   '',
            orden: false, 
            tipo : "",
            title : asig.titulo,
            type : "number",
            lapso:asig.lapso,
            vertical:asig.vertical ? asig.vertical : false, 

        }
    })
    est_titulos=[
        {
            ...est_titulos[0],
            fija:true, minWidth:400,//window.innerWidth * 0.3,
            title:'APELLIDOS NOMBRES',
            formato:(dato)=>{
                return `${dato.apellidos} ${dato.nombres}`
            }
        }
    ]
    fila1 =fila1.length!==0 ? [...est_titulos.map(val=>{return{...val, title:'ESTUDIANTES', orden:false}}), ...fila1] :[];
    est_titulos={filas:2 ,datos:[fila1,[...est_titulos, ...fila2]], values:[...est_titulos,...fila2]};
    return est_titulos
} 